export default __webpack_public_path__ + "static/media/dafina 2.6000ba41.png";